module.exports = __webpack_public_path__ + "static/media/face-error.5b0f80b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/face-error.png
// module id = 87
// module chunks = 0